import '.cx{font-size:1.125rem;}.ssr-plugin'
import '.ec{line-height:1.75rem;}.ssr-plugin'
import '.eq{text-decoration:none;}.ssr-plugin'
import '.fn{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cx ec"
    >
      {translations.privacySubtitle}{' '}
      <a className="eq fn"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="eq fn"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
